module.exports = __webpack_public_path__ + "img/lernaean_fountain_small.0f6cb310.png";